import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StatusComponent} from './status/status.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DpeComponent } from './dpe/dpe.component';
import { GesComponent } from './ges/ges.component';

@NgModule({
    declarations: [StatusComponent, DpeComponent, GesComponent],
    exports: [StatusComponent, GesComponent, DpeComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule
    ]
})
export class FavoriteModule {
}
